import { Component } from '@angular/core';
import { PanelLocationsService } from '../../services/Panel-Locations.service';
import { Observable, Subscription, of } from 'rxjs';
import { ILocationDTO } from 'src/app/features/routeMap/models/GeoPosLocations/IGetLastGeoJson';

@Component({
  selector: 'location-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.css']
})
export class SearchBarComponent {

  globalFinder: string = "";
  isVisible: boolean = true;

  filteredOptions: Observable<void | ILocationDTO[]>;

  subscription_GetSearch: Subscription;
  subscription_GetVisibility: Subscription;

  constructor(
    private panelLocationsService: PanelLocationsService
  ) 
  {
    this.subscription_GetSearch = this.panelLocationsService
      .getSearchData() .subscribe((data: string) => {
        this.globalFinder = data;
      });

      this.subscription_GetVisibility = this.panelLocationsService
      .getSearchVisibility() .subscribe((data: boolean) => {
        this.isVisible = data;
      });
  }

  ngOnDestroy(): void {
    if (this.subscription_GetSearch)
      this.subscription_GetSearch.unsubscribe();
    if (this.subscription_GetVisibility)
      this.subscription_GetVisibility.unsubscribe();
  }

  onGlobalFilter(event: any) {
    this.panelLocationsService.setVisibilityPanel(true);
    this.panelLocationsService.setSearchVisibility(false);
    this.panelLocationsService.setSearchData(this.globalFinder);
  }
}
